module.exports = __webpack_public_path__ + "static/media/white_category_icon_c3.153d6ab3.svg";